/** @format */
import { useTranslation } from 'next-i18next';
import React, { useContext } from 'react';

import { MarketContext } from '@toucan/client/global/market';

import { useSimilarModelRecommendations } from '@toucan/client/features/search/components/model-search-results/hooks/use-similar-model-recommendations';
import { SearchResultsType } from '@toucan/client/features/search/components/model-search-results/types';

import { ModelRecommendationsCarousel } from './components/model-recommendations-carousel';
import { ModelRecommendationsCarouselSkeleton } from './components/model-recommendations-carousel/skeleton';

export const OutOfStockRecommendations = ({
    searchResults,
    noInStockResults,
}: {
    searchResults: SearchResultsType;
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    noInStockResults: boolean;
}) => {
    const { activeMarket } = useContext(MarketContext);
    const { t } = useTranslation();

    function getModelsIdsFromSearchResults() {
        return searchResults.results
            .map(({ modelId }) => Number(modelId.values[0]))
            .filter((modelId) => !isNaN(modelId));
    }

    const outOfStockRecommendations = useSimilarModelRecommendations(
        getModelsIdsFromSearchResults(),
        activeMarket.code,
        {
            enabled: noInStockResults,
        }
    );

    if (outOfStockRecommendations.isFetching) {
        return <ModelRecommendationsCarouselSkeleton />;
    }

    if (outOfStockRecommendations.data) {
        return (
            <ModelRecommendationsCarousel
                title={t('Similar products')}
                pageModelIds={getModelsIdsFromSearchResults()}
                modelRecommendations={{
                    ...outOfStockRecommendations.data,
                    isEnabled: true,
                    variant: null,
                }}
            />
        );
    }

    return null;
};
